import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Tierart } from '../../administration/tierarten/tierart';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { KieneTableService } from '../kiene-table/kiene-table.service';

@Component({
    selector: 'kiene-animal-type-selector',
    templateUrl: './animal-type-selector.component.html',
    styleUrls: ['./animal-type-selector.component.scss'],
})
export class AnimalTypeSelectorComponent implements OnInit, AfterViewInit {
    tierarten: Tierart[] = [];
    tierartCtrl = new UntypedFormControl();

    @ViewChild('selector') selector: MatSelect;

    @Input('materialId') materialId: number;

    @Input('selectedTierartId') selectedTierartId: number;

    @Input('focused') focused = true;

    @Input('probenbegleitschein') probenbegleitschein = false;

    @Output('tierartSelectionChanged')
    tierartSelectionChanged = new EventEmitter<Tierart>();

    constructor(
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {
        //
    }

    ngOnInit() {
        this.loadTierartenForMaterial();
    }

    ngAfterViewInit() {
        if (this.selectedTierartId) {
            const tierart = new Tierart();
            tierart.tierart_id = this.selectedTierartId;
            this.tierartCtrl.setValue(tierart);
        }
        setTimeout(() => {
            if (this.focused) {
                this.selector?.focus();
            }
        }, 700);
    }

    loadTierartenForMaterial() {
        if (this.probenbegleitschein) {
            this.api.get(this.apiBaseUrl + 'tierart/read_probenbegleitschein.php').subscribe(
                response => {
                    this.tierarten = response.records;
                    this.applySelectedTierart();
                },
                error => {
                    this.messageService.errorMessage('Tierarten konnten nicht geladen werden!', error);
                },
            );
        } else if (this.materialId != null) {
            let params = new HttpParams().append('artikel_id', this.materialId.toString());
            this.api.get(this.apiBaseUrl + 'artikel_tierart/read.php', params).subscribe(
                response => {
                    this.tierarten = response.records;
                    this.applySelectedTierart();
                },
                error => {
                    this.messageService.errorMessage('Tierarten konnten nicht geladen werden!', error);
                },
            );
        } else {
            this.api.get(this.apiBaseUrl + 'tierart/read.php').subscribe(
                response => {
                    this.tierarten = response.records;
                    this.applySelectedTierart();
                },
                error => {
                    this.messageService.errorMessage('Tierarten konnten nicht geladen werden!', error);
                },
            );
        }
    }

    private applySelectedTierart() {
        if (!this.selectedTierartId || !this.tierarten?.length) {
            return;
        }
        const match = this.tierarten.find(t => KieneUtils.sameId(t.tierart_id, this.selectedTierartId));
        if (match) {
            this.tierartCtrl.setValue(match);
        }
    }

    tierartChanged(event: MatSelectChange) {
        console.debug(event.value);
        this.tierartSelectionChanged.emit(event.value);
    }

    tierartComparator(t1: Tierart, t2: Tierart): boolean {
        if (t1 && t2) {
            return KieneUtils.sameId(t1.tierart_id, t2.tierart_id);
        }
        return false;
    }
}
